
interface GprofileAboutProps {
  bio: string;
}

const GprofileAbout = ({ bio }: GprofileAboutProps) => {
  return (
    <div className="px-4 py-6 border-b border-ice-white/10">
      <h2 className="text-lg font-semibold text-toxic-green mb-3">About Me</h2>
      <p className="text-ice-white/90 leading-relaxed text-base">
        {bio}
      </p>
    </div>
  );
};

export default GprofileAbout;
